export const SITE_SECTION_RAKUTEN: string = "0000001021";
export const SITE_SECTION_BIZGEEVA: string = "0000001020";
export const SITE_SECTION_HIKICA_BUY: string = "0000001010";

export function isRakutenSiteSection(siteSection: string | undefined){
    return SITE_SECTION_RAKUTEN === siteSection;
}
export function isBizGeevaSiteSection(siteSection: string | undefined){
    return SITE_SECTION_BIZGEEVA === siteSection;
}
export function isHikicaBuySiteSection(siteSection: string | undefined){
    return SITE_SECTION_HIKICA_BUY === siteSection;
}